export enum ValidationAction {
  "accept" = "accept",
  "reject" = "reject",
}

export enum ValidationAssetType {
  "image" = "image",
  "mask" = "mask",
}

export type AssetsReadyForValidationResponseData = {
  assetId: string;
  episodeId: string;
  type: ValidationAssetType;
}[];

export type ValidateAssetRequestData = {
  action: ValidationAction;
  id: string;
  rejectionReasons?: string[];
  notes?: string;
};

export type AssignUserToEpisodesRequestData = {
  episodeIds: string[];
};
